import * as React from 'react';
import { observer } from 'mobx-react';
import { translation } from '../../i18n';
import { IObservableValue, observable } from 'mobx';
import { emptyValidationErrors, ValidationErrors } from '../../api/restApi';
import { Dialog } from '@material-ui/core';
import { DialogTitle } from '@material-ui/core';
import { Spinner } from '../../spinner/Spinner';
import { createPicker } from '../../util/picker';
import { TextField } from '@material-ui/core';
import { renderRemainingErrors, textFieldErrorProps } from '../../util/formUtils';
import { DialogContent } from '@material-ui/core';
import { DialogActions } from '@material-ui/core';
import { Button } from '@material-ui/core';
import { isValidColumn } from '../../util/validations';
import { ColumnRequest } from '../columnTypes';

interface Props {
  onClose: () => void;
  onSave: (column: ColumnRequest) => void;
  open: boolean;
}


@observer
export class NewColumnDialog extends React.Component<Props, {}> {

  @observable private column: ColumnRequest = {title: ''};
  @observable private validationErrors: ValidationErrors = emptyValidationErrors();
  private loading: IObservableValue<boolean> = observable.box(false);

  constructor(props: Props) {
    super(props);
  }

  public render() {
    const errorPicker = createPicker(this.validationErrors.fieldErrors);

    return (
      <Dialog
        id="newColumnDialog"
        open={this.props.open}
        onClose={this.props.onClose}
        fullWidth={true}
        maxWidth="md"
      >
        <DialogTitle id="form-dialog-title">{translation.t('newColumnDialog.title')}</DialogTitle>
        {
          this.loading.get() ?
            <Spinner/> :
            <>
              <DialogContent>
                <TextField
                  autoFocus={true}
                  id="column_input_title"
                  label={translation.t('column.title')}
                  margin="dense"
                  fullWidth={true}
                  value={this.column.title}
                  onChange={ev => {
                    this.column.title = ev.target.value;
                  }}
                  required={true}
                  {...textFieldErrorProps(errorPicker.pick(e => e.field === 'title'))}
                />
                {renderRemainingErrors(errorPicker.remaining())}
              </DialogContent>
              <DialogActions>
                <Button onClick={() => {
                  this.column = {title: ''};
                  this.props.onClose();
                }} color="primary">
                  {translation.t('actions.cancel')}
                </Button>
                <Button onClick={() => this.onSaveClicked()} color="primary">
                  {translation.t('actions.save')}
                </Button>
              </DialogActions>
            </>
        }
      </Dialog>
    );
  }

  private onSaveClicked() {
    this.validationErrors = isValidColumn(this.column);
    if (this.validationErrors === undefined || this.validationErrors.fieldErrors.length === 0) {
      this.props.onSave(this.column);
      this.column = {title: ''};
    }
  }
}
